import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "135",
  height: "124",
  viewBox: "0 0 135 124",
  fill: "none",
  class: "fill-current"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M132.85 1.05002H104.03C102.783 1.05002 102.158 2.55802 103.04 3.43997L131.86 32.2601C132.742 33.142 134.25 32.5174 134.25 31.2701V2.45002C134.25 1.67682 133.623 1.05002 132.85 1.05002Z",
      fill: "#9E579E"
    }, null, -1),
    _createElementVNode("path", {
      d: "M120.775 12.6H104.555C103.308 12.6 102.683 14.108 103.565 14.99L119.785 31.2101C120.667 32.092 122.175 31.4674 122.175 30.2201V14C122.175 13.2268 121.548 12.6 120.775 12.6Z",
      fill: "#3DABE0"
    }, null, -1),
    _createElementVNode("path", {
      d: "M120.775 12.6C121.549 12.6001 122.175 13.2272 122.175 14.0004V22.5746L112.2 12.6H120.775Z",
      fill: "#0F4499"
    }, null, -1)
  ])))
}
export default { render: render }